import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcFavorite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.64 6.063a4.25 4.25 0 0 0-6.011 0l-1.628 1.629-1.629-1.629a4.25 4.25 0 0 0-6.01 6.01l6.858 6.859q.073.072.153.127l.017.012.016.013A.99.99 0 0 0 12.713 19l6.926-6.926a4.25 4.25 0 0 0 0-6.01m-7.072-1.06a5.75 5.75 0 1 1 8.132 8.131l-6.927 6.927a2.49 2.49 0 0 1-3.27.22 2.6 2.6 0 0 1-.343-.288L3.3 13.134a5.75 5.75 0 0 1 8.132-8.131l.568.567z",
    clipRule: "evenodd"
  }));
}
var IcFavorite = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFavorite));

export { IcFavorite as I };
